const CSS_CLASSES = {
	CONTAINER: 'radio__container',
};

export { CSS_CLASSES };
